import React from 'react';
import { observer, inject } from 'mobx-react';

import './App.css';
import { RouteComponentProps, withRouter } from 'react-router-dom';

import { AppRoutes } from './AppRoutes';
import { Header } from './Header';
import { Navigation } from './Navigation';
import { SpinnerModal } from './components/common/spinner-modal';
import { LoadingStore } from './stores/loading-store';
import { TermsModal } from './components/common/terms-modal';
import { FurtherConsiderationsEntryStore } from './stores/further-considerations-entry-store';
import { ErrorBoundary } from './components/common/error-boundary';

// TODO: put this in a separate file
import { library } from '@fortawesome/fontawesome-svg-core';
import { faTint, faTrashAlt, faEye, faUserPlus, faChartBar, 
  faExternalLinkAlt, faFileDownload, faTable, faChevronUp, faChevronDown, 
  faUserFriends, faInfoCircle, faUserEdit, faEdit } 
  from '@fortawesome/free-solid-svg-icons';
library.add(faTint, faTrashAlt, faEye, faUserPlus, faChartBar,
  faExternalLinkAlt, faFileDownload, faTable, faChevronUp, faChevronDown, 
  faUserFriends, faInfoCircle, faUserEdit, faEdit);

interface AppProps extends RouteComponentProps<any> {
  loadingStore?: LoadingStore;
  furtherConsiderationsEntryStore?: FurtherConsiderationsEntryStore;
}

@inject('loadingStore', 'furtherConsiderationsEntryStore')
@observer
class App extends React.Component<AppProps, {}> {

  render() {
    const { loadingStore, furtherConsiderationsEntryStore, location } = this.props;
    const showPDF = location.pathname.indexOf('pdf') > -1;

    if (showPDF) {
      return (
        <div className="App">
          <AppRoutes />
          <SpinnerModal show={loadingStore.showAppIsBusy} />
        </div>
      );
    }
    return (
      <div className="App">
        <Header />
        <ErrorBoundary>
          <Navigation />
          <AppRoutes />
          <SpinnerModal show={loadingStore.showAppIsBusy} />
          <TermsModal furtherConsiderationsEntryStore={furtherConsiderationsEntryStore} />
        </ErrorBoundary>
      </div>
    );
  }
}

export default withRouter<AppProps, React.ComponentType<any>>(App);
